// src/components/adminAttendance/ClientSide.jsx
import React, { useEffect, useState, useRef } from "react";
import { getClientSideList } from "../../config/services/employeeServices";

export default function ClientSideEmp({ params }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const cancelled = useRef(false);

  useEffect(() => {
    cancelled.current = false;

    (async () => {
      try {
        setLoading(true);
        setErrorMsg("");
        const res = await getClientSideList(params);
        if (cancelled.current) return;

        // Adjust to your API shape
        const payload = res?.data?.responseData?.result;

        if (Array.isArray(payload)) {
          setData(payload);
        } else {
          setData([]);
          setErrorMsg("Unexpected response format.");
        }
      } catch (e) {
        if (!cancelled.current) {
          setErrorMsg(e?.message || "Network error");
        }
      } finally {
        if (!cancelled.current) setLoading(false);
      }
    })();

    return () => {
      cancelled.current = true;
    };
  }, [JSON.stringify(params || {})]);

  return (
    <div
      style={{
        maxWidth: 1680,         // make the table container a bit narrower
        margin: "50px auto",

      }}
    >
      <h3 className="mb-4" style={{ fontWeight: 600 }}>
        Client Side Employees
      </h3>

      <div className="table-responsive" style={{ fontSize: 14 /* smaller text */ }}>
        {loading && <div style={{ padding: 8 }}>Loading…</div>}
        {errorMsg && (
          <div className="text-danger" style={{ padding: 8 }}>
            {errorMsg}
          </div>
        )}

        <table className="table table-lg table-bordered">
          <thead className="white bg_blue">
            <tr>
              <th style={{ width: 80 }}>S.No</th>
              <th style={{ width: 140 }}>Employee ID</th>
              <th style={{ minWidth: 220 }}>Name</th>
              <th style={{ width: 140 }}>Client Side</th>
              <th style={{ minWidth: 220 }}>Client Location</th>
              <th style={{ minWidth: 220 }}>Client Name</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((r, idx) => (
                <tr key={r?._id || r?.employeeId || idx}>
                  <td>{idx + 1}</td>
                  <td>{r?.mobId ?? ""}</td>
                  <td>{r?.employeeName ?? ""}</td>
                  <td>{r?.clientSide == null ? "" : r.clientSide ? "Yes" : "No"}</td>
                  <td>{r?.clientLocation ?? ""}</td>
                  <td>{r?.clientName ?? ""}</td>
                </tr>
              ))
            ) : !loading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  No data available
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
